import { use, default as i18n } from "i18next";
import BrowserLanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import config from "./config";

use(BrowserLanguageDetector).use(initReactI18next).init(config);

document.documentElement.lang = i18n.language?.split("-")[0] || "pt";
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
